import React, { Component } from 'react';
import { toggleOptionsMenu } from '../lib/functions';
import { ReactComponent as More } from '../assets/ico-more-tbep.svg';


class Options extends Component {
    render() {
        return (
            <div className="options">
                <More className="more-icon" onClick={toggleOptionsMenu} max-width="50%"/>
            </div>
        );
    }
}

export default Options;